<div class="add_new_md">
    
    <form [formGroup]="addRazorpayAccountIdForm" (ngSubmit)="addStatusNotes()">
       <div class="add-header">
        <div class="md-header">
            <div class="row">
                <div class="col-sm-9">
                    Add Razorpay account id
                </div>
                <!-- <div class="col-sm-3">
                    
                </div> -->
                <div class="col-sm-3" style="text-align: right;margin-top: -5px;">
                    <button type="button" class="cenl_btn" (click)="closePopup()"><span class="material-icons cenl_btn_icon ">
                        close
                        </span></button>
                </div>
            </div>
        </div>
       </div>
           
        
        <div class="add_scroll">
            <div class="ad_ox">
               
               
               
              <br>
         
                
                <div class="form-group">
                    <label for="Description">Account id*</label>
                    <textarea rows="4" cols="50" id="Notes" autocomplete="off" formControlName="razorpayAccountId" placeholder="Enter razorpay account id for this merchant"></textarea>
                </div>
                <!-- <strong *ngIf="addDiscountForm.get('description').invalid && addDiscountForm.get('description').touched" style="color: 'red'; font-size: small">Field is manadatory</strong> -->
            </div>
        </div>

        <div class="add_footer">
            <div class="md-footer">
                <div class="row">
                    <div class="col-sm-4">
                    </div>
                    <div class="col-sm-4" style="
                    text-align: right;
                ">
                        <button type="button" class="footer_button_cancel" (click)="closePopup()">Cancel</button>
                    </div>
                    <div class="col-sm-4" style="
                    text-align: right;
                ">
                        <button type="submit" class="footer_button" [disabled]="addRazorpayAccountIdForm.invalid">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
